import { useTranslation } from "react-i18next";
import { Badge } from "@tellescope/ui";

export interface CapabilityBadgesProps {
  capabilities: Record<string, boolean | undefined>;
  idPrefix: string;
}

export const CapabilityBadges = ({ capabilities, idPrefix }: CapabilityBadgesProps) => {
  const { t } = useTranslation("onboarding");
  const enabledCapabilities = Object.entries(capabilities).filter(([, value]) => !!value);

  return (
    <>
      {enabledCapabilities.map(([key]) => {
        const normalized = key.toLowerCase();

        return (
          <Badge key={idPrefix + key} className="bg-blue-200 text-blue-800 uppercase rounded-full">
            {normalized === "sms"
              ? t("SMS")
              : normalized === "mms"
              ? t("MMS")
              : normalized === "fax"
              ? t("Fax")
              : normalized === "voice"
              ? t("Voice")
              : ""}
          </Badge>
        );
      })}
    </>
  );
};
